import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Layout, Menu, Image, Drawer, Button } from 'antd';
import { MenuOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';

import './styles/App.css';
import './styles/ColourScheme.css';

import { PageHome } from './app/PageHome';
import { AboutResearchers } from './app/PageAboutResearchers';
import { AppFooter } from './app/AppFooter';

import { PageDataDonation } from './features/donationFlow/PageDataDonation';

// Pages for data request guides
import ChatGPTRequest from './platforms/chatgpt/ChatGPTRequest';
import GeminiRequest from './platforms/gemini/GeminiRequest';
import ClaudeRequest from './platforms/claude/ClaudeRequest';
import DeepSeekRequest from './platforms/deepseek/DeepSeekRequest';
import MistralRequest from './platforms/mistral/MistralRequest';
import GrokRequest from './platforms/grok/GrokRequest';


const { Content, Header, Sider } = Layout;

const App = () => {
  useEffect(() => {
    document.title = 'Conversational AI data Donator';
  }, []);

  const [useMobileVersion, setUseMobileVersion] = useState(window.innerWidth <= 768);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState(window.location.pathname || '/');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setUseMobileVersion(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const updateMenu = (key) => {
    if (currentMenuItem === key) {
      window.location.reload(false);
    }
    setCurrentMenuItem(key);
  };

  const mobileMenuClick = (key) => {
    setVisible(false);
    updateMenu(key);
  };

  const showDrawer = () => {
    setVisible(true);
    setSubmenuOpen(false);
  };

  // ----- Refactored Desktop Menu -----
  const getMenu = () => {
    const items = [
      {
        key: '/',
        label: <Link to="/">Home</Link>,
      },
      {
        key: '/donate',
        label: <Link to="/donate">Data Donation</Link>,
      },
      {
        key: 'sub2',
        label: 'Requesting Data Guides',
        children: [
          { key: '/guide/chatgpt', label: <Link to="/guide/chatgpt">ChatGPT</Link> },
          { key: '/guide/gemini', label: <Link to="/guide/gemini">Gemini</Link> },
          { key: '/guide/claude', label: <Link to="/guide/claude">Claude</Link> },
          { key: '/guide/deepseek', label: <Link to="/guide/deepseek">DeepSeek</Link> },
          { key: '/guide/mistral', label: <Link to="/guide/mistral">Mistral</Link> },
          { key: '/guide/grok', label: <Link to="/guide/grok">Grok</Link> }
        ],
      },

      {
        key: '/about/researchers',
        label: <Link to="/about/researchers">Research Team</Link>,
      },
    ];

    return (
      <Menu
        className="Sider"
        theme="dark"
        mode="inline"
        onClick={(e) => updateMenu(e.key)}
        selectedKeys={[currentMenuItem]}
        items={items} // The fix is here (for menu warning)
      />
    );
  };

  // ----- Mobile Menu -----
  const getMenuMobile = () => (
    <div>
      <div>
        <Button type="text" onClick={() => mobileMenuClick('/')} className="MenuButton">
          <Link to="/">Home</Link>
        </Button>
      </div>
      <div>
        <Button type="text" onClick={() => mobileMenuClick('/donate')} className="MenuButton">
          <Link to="/donate">Data Donation</Link>
        </Button>
      </div>
      <div>
        <Button
          type="text"
          onClick={() => setSubmenuOpen(!submenuOpen)}
          icon={submenuOpen ? <UpOutlined /> : <DownOutlined />}
          className="MenuButton"
        >
          Requesting Data Guides
        </Button>
      </div>
      {['chatgpt'].map((item) => (
        <div key={item}>
          <Button
            type="text"
            onClick={() => mobileMenuClick(`/guide/${item}`)}
            hidden={!submenuOpen}
            className="SubmenuButton"
            style={{ textTransform: 'capitalize' }}
          >
            <Link to={`/guide/${item}`}>{item}</Link>
          </Button>
        </div>
      ))}
      <div>
        <Button type="text" onClick={() => mobileMenuClick('/about/researchers')} className="MenuButton">
          <Link to="/about/researchers">Research Team</Link>
        </Button>
      </div>
    </div>
  );

  return (
    <div className="App">
      <Router>
        <Layout>
          <Header className="Header">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <Link to="/" onClick={() => updateMenu('/')}>
                <Image className="Logo" src={process.env.PUBLIC_URL + '/Images/MPI_Logo_White.png'} preview={false} />
              </Link>
              <Button
                className="MenuIconButton"
                type="text"
                onClick={showDrawer}
                hidden={!useMobileVersion}
                icon={<MenuOutlined />}
              />
              <Drawer
                placement="top"
                height="400"
                onClose={() => setVisible(false)}
                open={visible}
              >
                {getMenuMobile()}
              </Drawer>
            </div>
          </Header>

          <Layout>
            <Sider className="Sider" hidden={useMobileVersion}>
              {getMenu()}
            </Sider>

            <Content className="Main-content">
              <Route path="/guide/chatgpt"><ChatGPTRequest /></Route>
              <Route path="/guide/gemini"><GeminiRequest /></Route>
              <Route path="/guide/claude"><ClaudeRequest /></Route>
              <Route path="/guide/deepseek"><DeepSeekRequest /></Route>
              <Route path="/guide/mistral"><MistralRequest /></Route>
              <Route path="/guide/grok"><GrokRequest /></Route>
              <Route path="/about/researchers"><AboutResearchers /></Route>
              <Route exact path="/donate"><PageDataDonation /></Route>
              <Route exact path="/"><PageHome /></Route>
            </Content>
          </Layout>
          <AppFooter />
        </Layout>
      </Router>
    </div>
  );
};

export default App;
